import styles from "./style.module.css";

function Form({ customClass, children, ...props }) {
  return (
    <form className={styles[customClass]} {...props}>
      {children}
      required
    </form>
    
  );
}

export default Form;
